import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Observable} from 'rxjs';
import {MapPosition} from 'app/model/mapPosition';

export class Button extends Component {
    static get propTypes() {
        return {
            onClick$: PropTypes.instanceOf(Observable).isRequired,
            children: PropTypes.any.isRequired,
            className: PropTypes.string,
            mapPosition: PropTypes.instanceOf(MapPosition),
        };
    }

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const {mapPosition} = this.props;

        this.props.onClick$.next({mapPosition});
    }

    render() {
        const {className, children} = this.props;

        return (
            <button type="button" className={`btn ${className}`} onClick={this.handleClick}>{children}</button>
        );
    }
}
